import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CustomLayoutComponent } from "../layout/custom-layout/custom-layout.component";
import { InternationalActivitiesdetailComponent } from "./international-activities-detail.component";

const routes: Routes = [
    {
    path: 'international-activities-detail',
        component: CustomLayoutComponent,
        children: [
          { path: ':id', component: InternationalActivitiesdetailComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class InternationalActivitiesdetailRoutingModule { }
